import config from "../config";
import { LOGOUT } from "./../types/authenticationType";
import localStorage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";
import { persistReducer } from "redux-persist";
import baseReducer from "./baseReducer";

const storage = config.isSessionStorage ? sessionStorage : localStorage;

const persistConfig = {
    key: "root",
    storage,
    whitelist: [
        "authenticationReducer",
        "cpayAppReducer",
        "issuerReducer",
        "globalParametersReducer",
        "appReducer"
    ]
};

const rootReducer = (state, action) => {
    /**
     * when a logout action is dispatched it will reset redux state
     */
    if (action.type === LOGOUT) {
        state = undefined;
        storage.removeItem("persist:root");
        config.isSessionStorage
            ? sessionStorage.removeItem("persist:root")
            : localStorage.removeItem("persist:root");
        return baseReducer(state, action);
    }
    return baseReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
